
import Vue from 'vue'
import Drift from 'drift-zoom'

export default Vue.extend({
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    imageSrcset: {
      type: String,
      required: false,
      default: undefined
    }
  },
  mounted() {
    try {
      new Drift(this.$el.getElementsByClassName('sliderImage')[0] as HTMLElement, {
        paneContainer: this.$el.getElementsByClassName('pr-ActiveImage_ZoomPaneContainer')[0] as HTMLElement,
        zoomFactor: 3,
        hoverDelay: 500,
        hoverBoundingBox: true
      })
    } catch (e) {}
  }
})
